import { LooseAutocomplete } from '@b2b/types/core';

export type ComboStatus = LooseAutocomplete<'Incomplete' | 'Not started' | 'Expired' | 'Active'>;

const MINUTES = 1000 * 60;

export function getComboStatus({
  startTime,
  endTime,
  priceList,
  discountId,
  now = new Date(),
}: {
  startTime: Date;
  endTime: Date;
  priceList?: unknown;
  discountId?: unknown;
  now?: Date;
}): ComboStatus {
  if (!priceList && !discountId) {
    return 'Incomplete';
  }

  const endDiff = (now.getTime() - endTime.getTime()) / MINUTES;
  const startDiff = (now.getTime() - startTime.getTime()) / MINUTES;

  if (startDiff < 1) {
    return 'Not started';
  }
  if (endDiff > 1) {
    return 'Expired';
  }
  return 'Active';
}
